export const ADD_CROP_EXPLORATIONS = "addCropExplorations";
export const DELETE_CROP_EXPLORATIONS = "deleteCropExplorations";
export const DELETE_CROP_EXPLORATIONS_YEAR = "deleteCropExplorationsYear";
export const GET_CROP_EXPLORATIONS = "getCropExplorations";
export const UPDATE_CROP_EXPLORATIONS = "updateCropExplorations";
export const ADD_CROP_EXPLORATION_ENTRY = "addCropExplorationEntry";
export const UPDATE_CROP_EXPLORATION_ENTRY = "updateCropExplorationEntry";
export const DELETE_CROP_EXPLORATION_ENTRY = "deleteCropExplorationEntry";
export const DUPLICATE_CROP_EXPLORATION_ENTRY = "duplicateCropExplorationEntry";
export const MIGRATE_PSEUDO_CROP_EXPLORATIONS_TO_USER = "migratePseudoCropExplorationsToUser";
export const DISMISS_RECOMMENDATION = "dismissRecommendation";
export const GET_ADMIN_USERS = "getAdminUsers";

// Platform Terms & Conditions
export const ADD_PLATFORM_TERMS_CONSENT = "addPlatformTermsConsent";

// Crop explorations template -> admin panel
export const ADD_CROP_EXPLORATION_TEMPLATES = "addCropExplorationTemplates";
export const UPDATE_CROP_EXPLORATION_TEMPLATES = "updateCropExplorationTemplates";
export const GET_CROP_EXPLORATION_TEMPLATES = "getCropExplorationTemplates";

// Digital Agronomist
export const ADD_OR_UPDATE_DIGITAL_AGRONOMIST_PREFERENCES = "addOrUpdateDigitalAgronomistPreferences";
export const UPDATE_DIGITAL_AGRONOMIST_PREFERENCES = "updateDigitalAgronomistPreferences";
export const GET_DIGITAL_AGRONOMIST_PREFERENCES = "getDigitalAgronomistPreferences";

// Crop Mix Composer
export const CALCULATE_COVER_CROP_MIXES = "calculateCoverCropMixes";
export const GET_CROP_MIX_COMPOSER_SCORE_FACTORS = "getCropMixComposerScoreFactors";
export const GET_CROP_MIX_COMPOSER_SETTINGS = "getCropMixComposerSettings";
export const DELETE_CROP_MIX_COMPOSER_SETTINGS = "deleteCropMixComposerSettings";
export const GET_CROP_MIX_COMPOSER_CROPS = "getCropMixComposerCrops";
export const ADD_CROP_MIX_COMPOSER_CROPS = "addCropMixComposerCrops";
export const MUTATE_CROP_MIX_COMPOSER_SETTINGS = "mutateCropMixComposerSettings";
export const CALCULATE_CROP_MIX_POTENTIAL_PAYOUT = "calculateCropMixPotentialPayout";
export const GET_CROP_MIX_COMPOSER_COMMERCIAL_MIXES = "getCropMixComposerCommercialMixes";
export const EXPORT_CROP_MIX_COMPOSER_COMMERCIAL_MIXES = "exportCropMixComposerCommercialMixes";
export const UPDATE_CROP_MIX_COMPOSER_COMMERCIAL_MIXES = "updateCropMixComposerCommercialMixes";

// Farms & Farm details
export const GET_FARMS = "getFarms";
export const ADD_FARM = "addFarm";
export const DELETE_FARM = "deleteFarm";
export const GET_FARM_DETAILS = "getFarmDetails";
export const UPDATE_FARM_DETAILS = "updateFarmDetails";
export const GET_ALL_USER_VERIFICATION_FARM_TASKS = "getAllUserVerificationFarmTasks";

// Payouts
export const GET_FARM_PAYMENTS = "getFarmPayments";
export const GET_FARM_PAYMENT_ITEMS = "getFarmPaymentItems";

// Farm Admin
export const GET_FARM_AREA_SUMMARY = "getFarmAreaSummary";
export const GET_FARM_VERIFICATIONS = "getFarmVerifications";

// Fields
export const GET_FIELDS = "getFieldList";
export const GET_FARM_FIELD_LIST_AT_POINT_IN_TIME = "getFarmFieldListAtPointInTime";
export const SPLIT_FIELD = "splitField";
export const GET_FIELDS_ADMIN = "getFieldsAdmin";
export const GET_FIELDS_BASIC_DETAILS = "getFieldBasicDetails";
export const DELETE_FIELD = "deleteField";
export const DELETE_MULTIPLE_FIELDS = "deleteMultipleFields";
export const GET_FIELD_DETAILS = "getFieldDetails";
export const GET_FIELD_PRACTICES = "getFieldPractices";
export const ADD_FIELD_PRACTICE_PARTICIPATIONS = "addFieldPracticeParticipations";
export const DELETE_FIELD_PRACTICE_PARTICIPATIONS = "deleteFieldPracticeParticipations";
export const GET_FIELDS_CROP_RECOMMENDATIONS = "getFieldCropRecommendations";
export const UPDATE_FIELD = "updateField";
export const ADD_FIELD = "addField";
export const ADD_FIELD_SIMULATION = "addFieldSimulation";
export const GET_FIELD_SIMULATIONS = "getFieldSimulations";
export const ADD_SOC_SAMPLE = "addSocSample";
export const GET_SOC_SAMPLES = "getSocSamples";
export const GET_FIELD_EVALUATION_METRIC_CORRECTIONS = "getFieldEvaluationMetricCorrections";
export const MUTATE_FIELD_EVALUATION_METRIC_CORRECTION = "mutateFieldEvaluationMetricCorrection";
export const DELETE_FIELD_EVALUATION_METRIC_CORRECTION = "deleteFieldEvaluationMetricCorrection";
export const GET_FIELD_SIZE_UPDATES = "getFieldSizeUpdates";
export const CONFIRM_FIELD_REDZONE_ADMIN = "confirmFieldRedzoneAdmin";
export const VERIFY_FIELD = "verifyField";
export const GET_FIELD_VERIFICATIONS = "getFieldVerifications";
export const GET_FIELD_TASKS = "getFieldTasks";
export const GET_REDZONE_EXCEPTIONS = "getRedzoneExceptions";

// Modules
export const GET_MODULES = "getModules";

// crops
export const ADD_FIELD_CROP_PRACTICE = "addFieldCropPractice";
export const UPDATE_FIELD_CROP_PRACTICE = "updateFieldCropPractice";
export const DELETE_FIELD_CROP_PRACTICE = "deleteFieldCropPractice";

// Bulk action on crops
export const UPDATE_BULK_FIELD_CROP_PRACTICE = "updateBulkFieldCropPractice";

// verfications
export const VERIFY_FIELDS = "verifyFields";
export const VERIFY_FIELD_MODULE_ELEMENTS = "verifyFieldModuleElements";
export const UPDATE_FIELD_VERIFICATION_SIZE = "updateFieldVerificationSize";
export const UPDATE_FIELD_VERIFICATION_OFFICIAL_SIZE = "updateFieldVerificationOfficialSize";
export const ADD_VERIFICATION_RECALCULATION_TRIGGER = "addVerificationRecalculationTrigger";
export const GET_VERIFICATION_RECALCULATION_TRIGGER = "getVerificationRecalculationTrigger";
export const GET_LATEST_VERIFICATION_RECALCULATION_TRIGGER = "getLatestVerificationRecalculationTrigger";

// Carbon programs
export const GET_CARBON_PROGRAM_OUTCOMES = "getCarbonProgramOutcomes";
export const GET_CARBON_PROGRAM_BY_ID = "getCarbonProgramById";
export const GET_CARBON_PROGRAM_OUTCOMES_ADMIN = "getCarbonProgramOutcomesAdmin";
export const GET_CARBON_PROGRAM_BY_FARM_ID = "getCarbonProgramByFarmId";
export const GET_ALL_CARBON_PROGRAMS = "getAllCarbonPrograms";
export const ADD_FARM_TO_CARBON_PROGRAM = "addFarmToCarbonProgram";
export const GET_FARMS_BY_CARBON_PROGRAM = "getFarmsByCarbonProgram";
export const GET_INCENTIVES_POTENTIAL_PAYOUTS = "getIncentivesPotentialPayouts";
export const ADD_PROGRAM_TERMS_CONSENT = "addProgramTermsConsent";
export const GET_PROGRAM_CONTRACT = "getProgramContract";
export const GET_PROGRAM_CONTRACTS_ADMIN = "getProgramContractsAdmin";
export const GET_LATEST_PROGRAM_CONTRACTS = "getLatestProgramContracts";
export const GET_INCENTIVES_POTENTIAL_PAYOUTS_ADMIN = "getIncentivesPotentialPayoutsAdmin";

// Practices
export const GET_PRACTICES_CROPS = "getPracticesCrops";
export const GET_PRACTICES_FERTILIZERS_MINERAL = "getPracticesFertilizersMineral";
export const GET_PRACTICES_FERTILIZERS_ORGANIC = "getPracticesFertilizersOrganic";
export const GET_PRACTICES_FERTILIZERS_APPLICATIONS = "getPracticesFertilizersApplications";
export const GET_PRACTICES_PLANT_PPROTECTION = "getPracticesPlantProtections";
export const GET_PRACTICES_TILLAGES = "getPracticesTillages";
export const GET_PRACTICES_SEEDINGS = "getPracticesSeedings";
export const GET_PRACTICES = "getPractices";

// Field filters by practice
export const GET_FIELD_PRACTICE_FILTER_OPTIONS = "getFieldPracticeFilterOptions";
export const GET_PRACTICE_FILTERED_FIELD_IDS = "getPracticeFilteredFieldIds";

// Footprinting
export const FOOTPRINTING_FARM = "footprintingFarm";
export const FOOTPRINTING_FARM_CALCULATED_FOOTPRINT = "footprintingFarmCalculatedFootprint";
export const FOOTPRINTING_FARM_PRIMARY_DATA = "footprintingFarmPrimaryData";
export const FOOTPRINTING_FARM_PRIMARY_DATA_ADMIN = "footprintingFarmPrimaryDataAdmin";
export const FOOTPRINTING_FARM_RESOURCE_CONSUMPTION = "footprintingFarmResourceConsumption";
export const FOOTPRINTING_EMISSION_FACTORS_REFRIGERANTS = "footprintingEmissionFactorsRefrigerants";
export const FOOTPRINTING_FARM_REFRIGERANT_USAGE = "footprintingFarmRefrigerantUsage";
export const FOOTPRINTING_LAND_USE_CHANGES = "footprintingLandUseChanges";
export const FOOTPRINTING_FARM_LAND_USE_CHANGE_USAGE = "footprintingFarmLandUseChanges";
export const FOOTPRINTING_FARM_LAND_USE_CHANGE_USAGE_ADMIN = "footprintingFarmLandUseChangesAdmin";
export const FOOTPRINTING_FARM_CROP_PLANT_PROTECTION = "footprintingCropPlantProtectionByPrimaryDataId";

export const FOOTPRINTING_FARM_RESOURCE_RETAILERS = "footprintingFarmResourceRetailers";
export const FOOTPRINTING_FARM_RESOURCE_PURCHASES = "footprintingFarmResourcePurchases";

export const FOOTPRINTING_CROP = "footprintingCrop";
export const FOOTPRINTING_CROP_CALCULATED_FOOTPRINT = "footprintingCropCalculatedFootprint";
export const FOOTPRINTING_CROP_PRIMARY_DATA = "footprintingCropPrimaryData";
export const FOOTPRINTING_CROP_PRIMARY_DATA_ADMIN = "footprintingCropPrimaryDataAdmin";
export const FOOTPRINTING_CROP_SEEDINGS = "footprintingCropSeedings";
export const FOOTPRINTING_CROP_TILLAGES = "footprintingCropTillages";
export const FOOTPRINTING_CROP_SALES = "footprintingCropSales";
export const FOOTPRINTING_CROP_PURCHASERS = "footprintingCropPurchasers";
export const FOOTPRINTING_CROP_FERTILIZERS_MINERAL = "footprintingCropFertilizersMineral";
export const FOOTPRINTING_CROP_FERTILIZERS_ORGANIC = "footprintingCropFertilizersOrganic";
export const FOOTPRINTING_CROP_ASSESSMENTS_REQUIRING_REVIEW = "footprintingCropAssessmentsRequiringReview";

export const FOOTPRINTING_DAIRY = "footprintingDairy";
export const FOOTPRINTING_DAIRY_PRIMARY_DATA = "footprintingDairyPrimaryData";
export const FOOTPRINTING_DAIRY_FEED_ADDITIVE = "footprintingDairyFeedAdditive";
export const FOOTPRINTING_DAIRY_MANURE_STORAGE = "footprintingDairyManureStorage";
export const FOOTPRINTING_DAIRY_MANURE_ADDITIVE = "footprintingDairyManureAdditive";
export const FOOTPRINTING_DAIRY_FEED_PRODUCTION = "footprintingDairyFeedProduction";
export const GET_DAIRY_FEED_INFORMATION = "getDairyFeedInformation";
export const GET_DAIRY_HERD_DETAILS = "getDairyHerdDetails";
export const GET_DAIRY_HERD_SIZE = "getDairyHerdSize";
export const GET_DAIRY_COWS_SOLD = "getDairyCowsSold";

// Dairy reference tables
export const GET_DAIRY_COW_TYPES = "getDairyCowTypes";
export const GET_DAIRY_FEED_TYPES = "getDairyFeedTypes";
export const GET_DAIRY_FEED_ADDITIVES = "getDairyFeedAdditives";
export const GET_DAIRY_MANURE_STORAGE = "getDairyManureStorage";
export const GET_DAIRY_MANURE_ADDITIVES = "getDairyManureAdditives";

// platform-wide queries
export const GET_PLATFORM_CONTRACT = "getPlatformContract";
export const GET_PLATFORM_CONTRACTS_ADMIN = "getPlatformContractsAdmin";
export const GET_YEARLY_DATA_YEAR = "getYearlyDataYear";
export const GET_FULL_POPUP = "getFullPopup";
export const GET_REGIONS_BY_COUNTRY = "getRegionsByCountry";

// Admin experiments
export const GET_NDVI_SCORES = "getNdviScores";
export const GET_FLYOVERS = "getFlyovers";

// Field shapes
export const GET_FIELD_SHAPE_ADMIN = "getFieldShapeAdmin";
export const GET_FIELDS_SHAPE_ADMIN = "getFieldShapesAdmin";
export const GET_FIELD_VERIFICATION_SHAPE = "getFieldVerificationShape";
export const UPDATE_FIELD_SHAPE_AMDIN = "updateFieldShapeAdmin";
export const GET_FIELD_SHAPE = "getFieldShape";
export const GET_FIELD_SHAPES = "getFieldShapes";

// Admin Practices
export const EXPORT_DIGITAL_AGRONOMIST_CROP_PRACTICES = "exportDigitalAgronomistCropPractices";
export const UPDATE_DIGITAL_AGRONOMIST_CROP_PRACTICES = "updateDigitalAgronomistCropPractices";

// Admin Popup
export const GET_ALL_ADMIN_POPUPS = "getAllAdminPopups";
export const GET_ALL_ADMIN_POPUPS_BY_ID = "getAllAdminPopupsById";
export const UPDATE_ADMIN_POPUPS = "updateAdminPopups";

// Admin Settings
export const GET_ADMIN_SETTINGS = "getAdminSettings";
export const UPDATE_ADMIN_SETTINGS = "updateAdminSettings";

// Editing requests
export const ADD_EDITING_REQUEST = "addEditingRequest";
export const UPDATE_EDITING_REQUEST = "updateEditingRequest";
export const GET_VERIFICATION_EDITING_REQUESTS = "getVerificationEditingRequests";
export const UPDATE_VERIFICATION_STATUS = "updateVerificationStatus";
export const UPDATE_VERIFICATION_EDITING_REQUEST = "updateVerificationEditingRequest";

// Data submission
export const ADD_FARM_DATA_SUBMISSION = "addFarmDataSubmission";
export const GET_FARM_DATA_SUBMISSION_STATUS = "getFarmDataSubmissionStatus";
export const GET_FARM_REPORTING_YEAR = "getFarmReportingYear";
export const GET_DATA_SUBMISSION_DATES = "getDataSubmissionDates";

// Data submission admin
export const UPDATE_FARM_DATA_SUBMISSION_ADMIN = "updateFarmDataSubmissionAdmin";

export const GET_CACHE_INVALIDATION = "getCacheInvalidation";
